/**
 * App + this file is an example setup and not required by the final application.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { NaturalLanguageProvider } from './naturallanguage/naturallanguage.provider';
import { HTTPStore } from './_shared/http/http.store.js';
import register from './registerServiceWorker';
import localForage from 'localforage';
import './polyfills';
// import { create } from 'mobx-persist';
import { Provider } from 'mobx-react';

register();

localForage.ready().catch(function () {
    /* so that webpack sees the rejected promise as handled */
    console.log('No storage!');
});

// Set up local storage
localForage.config({
    name: 'transport-govt-nz',
    version: 1.0,
    storeName: 'keyvaluepairs' // Should be alphanumeric, with underscores.
});

const httpStore = HTTPStore.getInstance(),
    rootEl = document.getElementById('natlang-root');

httpStore.rootURL = rootEl.getAttribute('data-basename');

ReactDOM.render(
    <Provider httpStore={httpStore}>
        <NaturalLanguageProvider />
    </Provider>,
    rootEl
);

if (module.hot) {
    module.hot.accept();
}
